<template>
  <v-dialog max-width="1000" v-model="show" persistent scrollable>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-icon class="draggable">mdi-drag</v-icon>
        {{ dialogTitle }}
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md fluid>
          <v-layout wrap>
            <v-flex xs12 sm4>
              <v-text-field label="Service Name" v-model="name"></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field label="Service Code" v-model="code"></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <service-type-list-select
                :supplier-type="supplierType"
                :service-type-name="typeName"
                @onSelect="onServiceTypeSelect($event)"
              ></service-type-list-select>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                label="Service Min Occupancy"
                v-model="minOccupancy"
                map="#"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                label="Service Std Occupancy"
                v-model="stdOccupancy"
                map="#"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                label="Service Max Occupancy"
                v-model="maxOccupancy"
                map="#"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-row v-if="value && value.id">
            <v-col cols="12">
              <h5 class="title">Contents</h5>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <contents :owner-id="value.id" owner-name="SERVICE"></contents>
            </v-col>
          </v-row>
          <v-row v-if="debug">
            <code>{{ value }}</code>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close')" color="warnings" text>Close</v-btn>
        <v-btn :disabled="!valid" @click="onCreateClick" text
          >Save and Continue</v-btn
        >
        <v-btn :disabled="!valid" @click="onCreateAndClose" color="primary"
          >Save and Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ServiceTypeListSelect from "../shared/ServiceTypeListSelect";
import Contents from "../shared/contents/Contents";
export default {
  name: "AdhocService",
  props: {
    value: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
  },
  components: {
    ServiceTypeListSelect,
    Contents,
  },
  data() {
    return {
      debug: false,
      name: "New Service",
      code: "",
      minOccupancy: 0,
      stdOccupancy: 0,
      maxOccupancy: 0,
      typeName: "",
    };
  },
  watch: {
    value(newVal) {
      if (newVal.name) {
        this.name = newVal.name;
      }
    },
  },
  computed: {
    dialogTitle() {
      return this.name;
    },
    valid() {
      return this.name != "" && this.typeName != "";
    },
  },
  methods: {
    onServiceTypeSelect(payload) {
      this.minOccupancy = payload.minOccupancy;
      this.stdOccupancy = payload.stdOccupancy;
      this.maxOccupancy = payload.maxOccupancy;
      this.typeName = payload.name;
    },
    onCreateClick() {
      if (this.valid) {
        //this.value && this.value.id ? this.value.id : undefined,
        const service = {
          name: this.name,
          typeName: this.typeName,
          code: this.code,
          minOccupancy: this.minOccupancy.toString(),
          stdOccupancy: this.stdOccupancy.toString(),
          maxOccupancy: this.maxOccupancy.toString(),
        };
        if (this.value && this.value.id) {
          this.$emit("update", { id: this.value.id, ...service });
        } else {
          this.$emit("create", service);
        }
      }
    },
    onCreateAndClose() {
      this.onCreateClick();
      this.$emit("close");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/AdhocService.vue